import { useState } from 'react'

import { ArrowsOutSimpleIcon } from '@phosphor-icons/react'

import { IconButton, Modal } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const OpenChartInModal = ({ show, modalTitle, chart }) => {
  const [showChart, setShowChart] = useState(false)

  if (!show) return null

  return (
    <>
      <IconButton variant="text" icon={<ArrowsOutSimpleIcon />} onClick={() => setShowChart(true)} />
      <Modal show={showChart} onClose={() => setShowChart(false)} title={modalTitle} size="xl">
        <Styles.Container>{chart}</Styles.Container>
      </Modal>
    </>
  )
}

export default OpenChartInModal
